export default __webpack_public_path__ + "static/media/description_1.81ad0102.svg";